import { Breadcrumbs, Menu, MenuItem } from "@material-ui/core";
import React, { Fragment, useMemo, useState } from "react";
import { ChevronRight } from "@material-ui/icons";
import {
  BreadcrumbDropdownArrow,
  SelectSiteContainer,
  BreadcrumbElement,
  BreadcrumbLink,
} from "../ProfileHeader.styles";

export const ResourceBreadcrumb = ({
  sites,
  organisationSlug,
  organisationName,
  slug,
  siteName,
  resourceName,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const showSiteDropdown = sites && sites.length;

  const handleSiteClick = (slug) => {
    window.location.href = `/schools/${slug}`;
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const sortedSites = useMemo(
    () => sites && sites.sort((a, b) => (a.siteName > b.siteName ? 1 : -1)),
    [sites]
  );

  return (
    <Fragment>
      <Breadcrumbs separator={<ChevronRight />}>
        <BreadcrumbLink href="/schools">Schools</BreadcrumbLink>
        {showSiteDropdown && (
            <BreadcrumbLink href={`/schools/${organisationSlug || slug}`}>
              {organisationName || resourceName}
            </BreadcrumbLink>
        )}
        {showSiteDropdown && (
          <SelectSiteContainer key={1} onClick={handleOpen}>
            <BreadcrumbElement secondary={1}>{ siteName || "Select a Site" }</BreadcrumbElement>
            <BreadcrumbDropdownArrow secondary={1} />
          </SelectSiteContainer>
        )}
        {!showSiteDropdown && (
          <BreadcrumbLink href={`/schools/${slug}`}>
            {siteName || resourceName}
          </BreadcrumbLink>
        )}
      </Breadcrumbs>
      {showSiteDropdown ? (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          {sortedSites.map((site, index) => (
            <MenuItem key={index} onClick={() => handleSiteClick(site.slug)}>
              {site.siteName}
            </MenuItem>
          ))}
        </Menu>
      ) : null}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/ProfileHeader/ResourceBreadcrumb/ResourceBreadcrumb.js